import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:solutions.apps.billabilityCalculator',
    'resource:solutions.apps.billabilityCalculator.pages.billabilityCalculator',
    'resource:solutions.mosaic.pages.billabilityCalculator.billabilityCalculator',
    'resource:solutions.mosaic.widgets.billabilityCalculator.billRateToSalary',
    'resource:solutions.mosaic.widgets.billabilityCalculator.salaryToBillRate',
  ],
  description: 'Simple billability calculator',
  name: 'Billability Calculator',
} as const satisfies core.quiver.Package
